import { useState, useEffect } from 'react';
import { StreakService, type UserStreak } from '@/services/streakService';

export function useStreak(email?: string | null) {
  const [streak, setStreak] = useState<UserStreak | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (email) {
      refreshStreak();
    } else {
      setStreak(null);
    }
  }, [email]);

  const refreshStreak = async () => {
    if (!email) return;
    setLoading(true);
    const result = await StreakService.getStreak(email);
    setStreak(result);
    setLoading(false);
  };

  const updateStreak = async () => {
    if (!email) return;
    const result = await StreakService.updateStreak(email);
    if (result) setStreak(result);
  };

  return { streak, loading, refreshStreak, updateStreak };
}
